import { render, staticRenderFns } from "./pay copy.vue?vue&type=template&id=e8e06824&scoped=true&"
import script from "./pay copy.vue?vue&type=script&lang=js&"
export * from "./pay copy.vue?vue&type=script&lang=js&"
import style0 from "./pay copy.vue?vue&type=style&index=0&id=e8e06824&prod&scoped=true&lang=scss&"
import style1 from "./pay copy.vue?vue&type=style&index=1&id=e8e06824&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e06824",
  null
  
)

export default component.exports